export function formatSubscriptionCurrency(
  amountCents: number | null | undefined,
  currency?: string | null,
): string {
  if (amountCents == null || Number.isNaN(amountCents as number)) return '-'
  const code = (currency || 'BRL').toUpperCase()
  const value = amountCents / 100
  try {
    return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: code }).format(value)
  } catch {
    return `R$ ${value.toFixed(2)}`
  }
}

export function formatSubscriptionIntervalLabel(raw?: string | null): string {
  const val = (raw || '').toLowerCase()
  if (val === 'year') return 'Anual'
  if (val === 'month') return 'Mensal'
  if (val === 'week') return 'Semanal'
  if (val === 'day') return 'Diário'
  return '-'
}

